<template>
<form @submit.prevent="submit" autocomplete="off">
  <ui-textbox label="Nazwa" name="name" type="text" v-model="item.name" :autofocus="autofocus" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz nazwę"></ui-textbox>

  <i-select name="template_type" label="Typ szablonu" v-model="item.template_type" :options="templateTypes" placeholder="Wybierz typ szablonu" required></i-select>


   <ui-textbox label="Treść szablonu" name="body" type="text" :rows="10" v-model="item.body" :multi-line="true"></ui-textbox>


  <div class="form-actions">
    <ui-button color="primary">{{ item.id ? 'Aktualizuj' : 'Dodaj' }}</ui-button>
  </div>
</form>
</template>

<script>
import Loading from '../../mixins/Loading'
import Notify from '../../mixins/Notify'
import Utils from '../../services/Utils'

import Templates from './../../services/Templates'

export default {
  mixins: [Loading, Notify],
  props: ['item'],
  data () {
    return {
      autofocus: true,
      title: 'Dodaj szablon',
      action: 'Dodaj szablon',
      templateTypes: Templates.templateTypes(),
      errorMessages: Utils.errorMessages(['required', 'min', 'numeric'])
    }
  },
  mounted () {
    if (this.item.id) {
      this.title = 'Aktualizuj szablon'
      this.action = 'Aktualizuj szablon'
    }
  },
  methods: {
    resetForm () {
      this.item = Templates.getBaseItem()
    },
    error () {
      this.notify('Nie mogę zapisać. Sprawdź czy wpisałeś nazwę')
    },
    success (res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('templates.update', this.item)
          this.notify('Zmieniłeś szablon')
          this.$router.push({name: 'admin.templates.show', params: {id: this.item.id}})
        }
      } else {
        if (res.status === 201) {
          this.$emit('templates.create', this.item)
          this.notify('Dodałeś szablon')
          this.$router.push({name: 'admin.templates.show', params: {id: res.data.item.id}})
        }
      }
    },
    submit () {
      let item = {}
      if (this.item.id) {
        item.id = this.item.id
      }
      item.name = this.item.name
      item.status = this.item.status
      item.body = this.item.body
      item.template_type = this.item.template_type

      if (this.item.id) {
        Templates.update(item).then(this.success, this.error)
      } else {
        Templates.create(item).then(this.success, this.error)
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// Form.vue?1f2b5847